<template>
  <v-dialog v-model="timeoutConfirmModal" max-width="500">
    <v-card title="Are you still there" :subtitle="resetModalSubtitle">
      <template v-slot:text>
        <!-- The edit form is provided by the parent via slot -->
        <slot name="edit" />
      </template>

      <v-divider />

      <v-card-actions class="bg-primary">
        <v-btn
          text="Cancel Registration"
          variant="plain"
          @click="timeoutConfirm"
        />
        <v-spacer />
        <v-btn text="Continue Registration" @click="timeoutReset" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script setup lang="ts">
const props = defineProps<{
  isActive: boolean;
  timeoutDuration?: number;
  modalDurationSeconds?: number;
}>();

const emits = defineEmits(["timeout"]);

const timeoutTimer = ref<NodeJS.Timeout>();

const timeoutConfirmModal = ref(false);

const resetModalDuration = ref(0);

const resetModalSubtitle = computed(
  () =>
    "The registration will reset in " +
    resetModalDuration.value +
    " second" +
    (resetModalDuration.value > 1 ? "s" : ""),
);

const timeoutReset = () => {
  timeoutConfirmModal.value = false;
  resetModalDuration.value = modalDurationSeconds;
  resetTimer();
};

watch(timeoutConfirmModal, () => {
  if (!timeoutConfirmModal.value) timeoutReset();
});

const processResetModalTimer = () => {
  if (resetModalDuration.value > 0) {
    setTimeout(processResetModalTimer, 1000);
    resetModalDuration.value = resetModalDuration.value - 1;
  } else {
    if (timeoutConfirmModal.value) timeoutConfirm();
  }
};

const timeoutConfirm = () => {
  emits("timeout");
  timeoutConfirmModal.value = false;
};

const handleTimeout = () => {
  if (timeoutConfirmModal.value == true || !props.isActive) return;
  timeoutConfirmModal.value = true;
  resetModalDuration.value = modalDurationSeconds;
  processResetModalTimer();
};

const timeoutDuration = 60000;

const modalDurationSeconds = 10;

const clearTimer = () => {
  if (timeoutTimer.value) {
    clearTimeout(timeoutTimer.value);
    timeoutTimer.value = undefined;
  }
};

const resetTimer = () => {
  clearTimer();
  if (props.isActive)
    timeoutTimer.value = setTimeout(handleTimeout, timeoutDuration);
};

onMounted(() => {
  document.addEventListener("mouseup", (e) => {
    resetTimer();
  });

  document.addEventListener("mousemove", (e) => {
    resetTimer();
  });

  // Keyboard events
  document.addEventListener("keydown", (e) => {
    resetTimer();
  });

  document.addEventListener("keyup", (e) => {
    resetTimer();
  });
});

watch(
  () => props.isActive,
  () => {
    if (props.isActive) clearTimer();
    else resetTimer();
  },
);
</script>
